var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 225,
    viewBox: "0 0 300 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_6415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.092 75.4153C104.24 75.2304 104.517 74.9346 104.924 74.5278C105.33 74.0841 105.885 73.6589 106.588 73.2521C107.29 72.8453 108.141 72.4941 109.139 72.1982C110.175 71.8654 111.358 71.699 112.689 71.699C114.649 71.699 116.442 72.0318 118.069 72.6974C119.696 73.3261 121.102 74.232 122.285 75.4153C123.468 76.5616 124.393 77.9298 125.058 79.5198C125.724 81.0729 126.057 82.7924 126.057 84.6782C126.057 86.6381 125.724 88.4685 125.058 90.1694C124.393 91.8334 123.394 93.2756 122.063 94.4958C120.732 95.7161 119.049 96.6775 117.015 97.3801C114.982 98.0827 112.578 98.434 109.805 98.434C108.104 98.434 106.495 98.2676 104.979 97.9348C103.5 97.565 102.132 97.0843 100.875 96.4926C99.6544 95.864 98.5636 95.1245 97.6021 94.274C96.6777 93.3865 95.9381 92.4436 95.3835 91.4452C94.9028 90.5207 94.6254 89.6702 94.5515 88.8937C94.5145 88.0802 94.6624 87.3776 94.9952 86.786C95.328 86.1943 95.8087 85.7321 96.4373 85.3993C97.1029 85.0665 97.8795 84.9001 98.7669 84.9001C99.5065 84.9001 100.209 85.048 100.875 85.3438C101.577 85.6027 102.132 86.0094 102.539 86.5641C103.352 87.7844 104.369 88.7828 105.589 89.5593C106.847 90.2989 108.252 90.6686 109.805 90.6686C110.766 90.6686 111.672 90.5577 112.523 90.3358C113.41 90.077 114.168 89.7072 114.797 89.2265C115.462 88.7088 115.98 88.0802 116.35 87.3406C116.72 86.6011 116.905 85.7136 116.905 84.6782C116.905 83.6798 116.72 82.8109 116.35 82.0713C115.98 81.2948 115.481 80.6661 114.852 80.1854C114.224 79.6677 113.484 79.2795 112.634 79.0206C111.783 78.7618 110.877 78.6324 109.916 78.6324C108.548 78.6324 107.346 78.9097 106.31 79.4644C105.312 79.9821 104.517 80.5367 103.925 81.1284C103.519 81.4242 103.038 81.6461 102.483 81.794C101.966 81.9419 101.429 82.0158 100.875 82.0158C100.135 82.0158 99.4325 81.9049 98.7669 81.683C97.7316 81.3133 96.8626 80.7401 96.16 79.9636C95.4944 79.1501 95.1986 78.1701 95.2725 77.0238L96.3819 66.4852C96.6407 64.1556 97.5282 62.3621 99.0443 61.1049C100.597 59.8107 102.428 59.1636 104.535 59.1636H120.343C121.527 59.1636 122.488 59.5333 123.228 60.2729C123.967 61.0125 124.337 61.9739 124.337 63.1572C124.337 64.3405 123.967 65.3204 123.228 66.0969C122.488 66.8365 121.527 67.2062 120.343 67.2062H106.699C106.218 67.2062 105.793 67.3172 105.423 67.539C105.09 67.7609 104.887 68.1861 104.813 68.8148L104.092 75.4153ZM148.427 98.434C145.432 98.434 142.788 97.9533 140.496 96.9918C138.24 96.0304 136.336 94.6807 134.783 92.9428C133.266 91.2048 132.12 89.1156 131.344 86.675C130.567 84.2345 130.179 81.5166 130.179 78.5214C130.179 75.5632 130.567 72.8638 131.344 70.4233C132.12 67.9828 133.266 65.8935 134.783 64.1556C136.336 62.4176 138.24 61.0864 140.496 60.162C142.788 59.2005 145.432 58.7198 148.427 58.7198C151.423 58.7198 154.048 59.2005 156.304 60.162C158.559 61.0864 160.445 62.4176 161.961 64.1556C163.514 65.8935 164.679 67.9828 165.456 70.4233C166.232 72.8638 166.62 75.5632 166.62 78.5214C166.62 81.5166 166.232 84.2345 165.456 86.675C164.679 89.1156 163.514 91.2048 161.961 92.9428C160.445 94.6807 158.559 96.0304 156.304 96.9918C154.048 97.9533 151.423 98.434 148.427 98.434ZM148.427 90.4468C150.017 90.4468 151.367 90.1694 152.476 89.6148C153.586 89.0231 154.473 88.2096 155.139 87.1742C155.841 86.1389 156.341 84.9001 156.636 83.458C156.969 81.9789 157.136 80.3333 157.136 78.5214C157.136 76.7465 156.969 75.138 156.636 73.6958C156.341 72.2167 155.841 70.9595 155.139 69.9241C154.473 68.8887 153.586 68.0937 152.476 67.539C151.367 66.9844 150.017 66.707 148.427 66.707C145.284 66.707 143.029 67.7794 141.66 69.9241C140.329 72.0688 139.664 74.9346 139.664 78.5214C139.664 80.3333 139.812 81.9789 140.107 83.458C140.44 84.9001 140.958 86.1389 141.66 87.1742C142.363 88.2096 143.269 89.0231 144.378 89.6148C145.488 90.1694 146.837 90.4468 148.427 90.4468ZM188.727 98.434C185.732 98.434 183.088 97.9533 180.796 96.9918C178.54 96.0304 176.636 94.6807 175.083 92.9428C173.566 91.2048 172.42 89.1156 171.644 86.675C170.867 84.2345 170.479 81.5166 170.479 78.5214C170.479 75.5632 170.867 72.8638 171.644 70.4233C172.42 67.9828 173.566 65.8935 175.083 64.1556C176.636 62.4176 178.54 61.0864 180.796 60.162C183.088 59.2005 185.732 58.7198 188.727 58.7198C191.723 58.7198 194.348 59.2005 196.604 60.162C198.859 61.0864 200.745 62.4176 202.261 64.1556C203.814 65.8935 204.979 67.9828 205.756 70.4233C206.532 72.8638 206.92 75.5632 206.92 78.5214C206.92 81.5166 206.532 84.2345 205.756 86.675C204.979 89.1156 203.814 91.2048 202.261 92.9428C200.745 94.6807 198.859 96.0304 196.604 96.9918C194.348 97.9533 191.723 98.434 188.727 98.434ZM188.727 90.4468C190.317 90.4468 191.667 90.1694 192.776 89.6148C193.886 89.0231 194.773 88.2096 195.439 87.1742C196.141 86.1389 196.641 84.9001 196.936 83.458C197.269 81.9789 197.436 80.3333 197.436 78.5214C197.436 76.7465 197.269 75.138 196.936 73.6958C196.641 72.2167 196.141 70.9595 195.439 69.9241C194.773 68.8887 193.886 68.0937 192.776 67.539C191.667 66.9844 190.317 66.707 188.727 66.707C185.584 66.707 183.329 67.7794 181.96 69.9241C180.629 72.0688 179.964 74.9346 179.964 78.5214C179.964 80.3333 180.112 81.9789 180.407 83.458C180.74 84.9001 181.258 86.1389 181.96 87.1742C182.663 88.2096 183.569 89.0231 184.678 89.6148C185.788 90.1694 187.137 90.4468 188.727 90.4468Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0349 159.416V143.605H74.1621V116.419H91.0751V143.605H106.889V99.3082H124.337V128.063H128.316V93.7344H145.764V158.102H167.831V195.636H176.077V178.925H195.017V188.809H205.89V144.563H219.322V177.313H232.754V205.531H219.322H207.808H205.89H195.017H188.87H179.025H176.077H167.831H160.086H145.764H141.378H132.651H128.316H124.337H115.203H108.985H106.889H91.0751H74.4449H74.1621H71.0089H45.9085V159.416H64.0349Z",
    fill: "#F5FAFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 4.49676,
    transform: "matrix(-1 0 0 1 211.02 164.184)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 4.49676,
    transform: "matrix(-1 0 0 1 230.506 180.672)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 4.49676,
    transform: "matrix(-1 0 0 1 220.763 191.164)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 4.49676,
    transform: "matrix(-1 0 0 1 217.766 152.941)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 4.49676,
    transform: "matrix(-1 0 0 1 211.02 147.695)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 88.1089 119.965)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.843,
    y: 102.728,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.577,
    y: 96.7324,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 79.8647 130.458)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.087,
    y: 113.221,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.821,
    y: 107.225,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.821,
    y: 130.458,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.811,
    y: 172.428,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.566,
    y: 161.186,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.087,
    y: 147.695,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.342,
    y: 175.426,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.098,
    y: 151.442,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.575,
    y: 150.693,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.536,
    y: 182.171,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.543,
    y: 190.415,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.305,
    y: 161.186,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 88.1089 130.458)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.843,
    y: 113.221,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.577,
    y: 107.225,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 88.1089 143.199)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 79.8647 154.44)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 70.1216 146.946)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 52.1348 162.685)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 63.377 162.685)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 57.3809 173.927)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.99784,
    height: 5.24622,
    transform: "matrix(-1 0 0 1 52.1348 184.419)",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.843,
    y: 125.961,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.577,
    y: 119.965,
    width: 2.99784,
    height: 5.24622,
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.292 196.678C236.152 196.678 236.013 196.697 235.873 196.697C232.05 187.825 223.212 181.613 212.919 181.613C199.12 181.613 187.941 192.772 187.941 206.526H246.175C246.175 201.086 241.756 196.678 236.302 196.678H236.292Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0575 199.017C36.1645 199.017 36.2714 199.031 36.3784 199.031C39.3015 192.267 46.0604 187.53 53.9315 187.53C64.4833 187.53 73.0317 196.039 73.0317 206.526H28.5001C28.5001 202.378 31.8796 199.017 36.0504 199.017H36.0575Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.992 195.985C198.809 195.985 197.683 196.188 196.622 196.54C193.866 193.504 189.9 191.579 185.459 191.579C177.155 191.579 170.424 198.271 170.424 206.527H210.596C210.596 200.705 205.848 195.985 199.992 195.985Z",
    fill: "#E3F7ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.262 204.787H210.094L213.132 194.221C213.489 193.247 214.867 193.247 215.224 194.221L218.259 204.787H218.262Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.216 197.673H212.14L212.779 195.445H215.576L216.216 197.673Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.278 201.368H211.078L211.717 199.141H216.636L217.278 201.368Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.812 204.787H208.542V205.49H219.812V204.787Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7777 196.17C68.8751 196.17 69.9207 196.36 70.9058 196.688C73.4635 193.854 77.1446 192.057 81.2664 192.057C88.9742 192.057 95.2217 198.304 95.2217 206.012H57.9356C57.9356 200.577 62.3425 196.17 67.7777 196.17Z",
    fill: "#E3F7ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.03 163.375H230.03V205.345H229.03V163.375Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.231 156.689C228.808 155.69 230.251 155.69 230.828 156.689L241.318 173.559C241.895 174.559 241.173 175.808 240.019 175.808H219.04C217.886 175.808 217.164 174.559 217.741 173.559L228.231 156.689Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.259 163.438C230.417 163.438 230.55 163.496 230.66 163.612C230.776 163.729 230.827 163.865 230.814 164.023L230.567 167.885C230.56 168.049 230.495 168.189 230.372 168.306C230.256 168.415 230.115 168.47 229.951 168.47H229.273C229.109 168.47 228.968 168.415 228.852 168.306C228.736 168.189 228.67 168.049 228.657 167.885L228.41 164.023C228.403 163.865 228.455 163.729 228.564 163.612C228.674 163.496 228.807 163.438 228.965 163.438H230.259ZM230.054 169.292C230.211 169.292 230.348 169.35 230.464 169.466C230.581 169.583 230.639 169.72 230.639 169.877V170.35C230.639 170.507 230.581 170.644 230.464 170.761C230.348 170.877 230.211 170.935 230.054 170.935H229.17C229.013 170.935 228.876 170.877 228.759 170.761C228.643 170.644 228.585 170.507 228.585 170.35V169.877C228.585 169.72 228.643 169.583 228.759 169.466C228.876 169.35 229.013 169.292 229.17 169.292H230.054Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6353 159.936H82.636V203.904H83.6353V159.936Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7685 143.891C84.0429 142.634 82.2289 142.634 81.5033 143.891L68.3162 165.099C67.5906 166.356 68.4976 167.927 69.9488 167.927H96.323C97.7742 167.927 98.6812 166.356 97.9556 165.099L84.7685 143.891Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2185 152.374C82.0205 152.374 81.8526 152.447 81.7149 152.594C81.5686 152.74 81.504 152.912 81.5212 153.11L81.8311 157.965C81.8397 158.172 81.9215 158.348 82.0764 158.494C82.2228 158.632 82.3993 158.701 82.6059 158.701H83.4581C83.6647 158.701 83.8411 158.632 83.9875 158.494C84.1338 158.348 84.2156 158.172 84.2328 157.965L84.5427 153.11C84.5513 152.912 84.4867 152.74 84.349 152.594C84.2113 152.447 84.0434 152.374 83.8454 152.374H82.2185ZM82.4767 159.734C82.2787 159.734 82.1066 159.807 81.9602 159.953C81.8139 160.1 81.7407 160.272 81.7407 160.47V161.064C81.7407 161.262 81.8139 161.434 81.9602 161.58C82.1066 161.727 82.2787 161.8 82.4767 161.8H83.5872C83.7852 161.8 83.9573 161.727 84.1037 161.58C84.25 161.434 84.3232 161.262 84.3232 161.064V160.47C84.3232 160.272 84.25 160.1 84.1037 159.953C83.9573 159.807 83.7852 159.734 83.5872 159.734H82.4767Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.057,
    y: 154.01,
    width: 0.999279,
    height: 49.9652,
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.933 137.033C192.654 135.783 194.458 135.783 195.179 137.033L208.291 158.12C209.013 159.37 208.111 160.932 206.668 160.932H180.444C179.001 160.932 178.099 159.37 178.821 158.12L191.933 137.033Z",
    fill: "#C8EEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.468 145.468C194.665 145.468 194.832 145.541 194.969 145.686C195.115 145.832 195.179 146.003 195.162 146.2L194.854 151.027C194.845 151.232 194.764 151.408 194.61 151.553C194.464 151.69 194.289 151.759 194.083 151.759H193.236C193.031 151.759 192.855 151.69 192.71 151.553C192.564 151.408 192.483 151.232 192.466 151.027L192.157 146.2C192.149 146.003 192.213 145.832 192.35 145.686C192.487 145.541 192.654 145.468 192.851 145.468H194.468ZM194.212 152.786C194.409 152.786 194.58 152.858 194.725 153.004C194.871 153.149 194.944 153.321 194.944 153.518V154.108C194.944 154.305 194.871 154.476 194.725 154.622C194.58 154.767 194.409 154.84 194.212 154.84H193.108C192.911 154.84 192.74 154.767 192.594 154.622C192.449 154.476 192.376 154.305 192.376 154.108V153.518C192.376 153.321 192.449 153.149 192.594 153.004C192.74 152.858 192.911 152.786 193.108 152.786H194.212Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.168 163.134H43.1595V205.491H44.168V163.134Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0836 158.31C44.4525 157.217 42.8749 157.217 42.2439 158.31L30.7752 176.754C30.1441 177.848 30.9329 179.214 32.195 179.214H55.1325C56.3946 179.214 57.1834 177.848 56.5523 176.754L45.0836 158.31Z",
    fill: "#C8EEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8657 165.688C42.6935 165.688 42.5475 165.751 42.4277 165.878C42.3004 166.006 42.2443 166.155 42.2593 166.328L42.5288 170.55C42.5363 170.73 42.6074 170.883 42.7422 171.01C42.8694 171.13 43.0229 171.19 43.2026 171.19H43.9437C44.1234 171.19 44.2769 171.13 44.4042 171.01C44.5314 170.883 44.6025 170.73 44.6175 170.55L44.887 166.328C44.8945 166.155 44.8384 166.006 44.7186 165.878C44.5988 165.751 44.4528 165.688 44.2806 165.688H42.8657ZM43.0903 172.088C42.9181 172.088 42.7684 172.152 42.6411 172.279C42.5138 172.407 42.4502 172.556 42.4502 172.728V173.245C42.4502 173.417 42.5138 173.567 42.6411 173.694C42.7684 173.821 42.9181 173.885 43.0903 173.885H44.056C44.2282 173.885 44.378 173.821 44.5052 173.694C44.6325 173.567 44.6961 173.417 44.6961 173.245V172.728C44.6961 172.556 44.6325 172.407 44.5052 172.279C44.378 172.152 44.2282 172.088 44.056 172.088H43.0903Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5916 204.611H78.7095L82.7571 191.404C83.2327 190.186 85.0683 190.186 85.544 191.404L89.5887 204.611H89.5916Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8659 195.718H81.4351L82.2872 192.934H86.0138L86.8659 195.718Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2811 200.338H80.0195L80.8717 197.554H87.426L88.2811 200.338Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6579 204.611H76.6406V205.49H91.6579V204.611Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3667 204.702H60.2051L63.2408 194.144C63.5975 193.17 64.9742 193.17 65.331 194.144L68.3645 204.702H68.3667Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3222 197.592H62.249L62.8881 195.366H65.6831L66.3222 197.592Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3841 201.285H61.188L61.8271 199.06H66.7429L67.3841 201.285Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9163 204.702H58.6533V205.405H69.9163V204.702Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.176 204.611H189.966L193.764 191.404C194.21 190.186 195.932 190.186 196.378 191.404L200.173 204.611H200.176Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.619 195.718H192.523L193.323 192.934H196.819L197.619 195.718Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.947 200.338H191.196L191.995 197.554H198.144L198.947 200.338Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.114 204.611H188.025V205.49H202.114V204.611Z",
    fill: "#DEEDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4615 96.8374C63.7345 95.7597 66.5962 95.5729 68.6539 97.0242C70.7116 98.4707 71.4868 101.129 71.9367 103.605C72.8411 101.747 74.9658 100.559 77.0235 100.76C79.0812 100.961 80.9332 102.542 81.4596 104.544C81.6462 105.253 81.7132 106.058 82.2539 106.551C82.7229 106.977 83.412 107.03 84.0437 107.059C86.7043 107.183 89.365 107.308 92.0257 107.432C93.5426 107.504 95.3754 107.777 95.9688 109.181C96.4856 110.402 95.6626 111.853 94.5045 112.495C93.3464 113.137 91.9635 113.175 90.6379 113.194C75.1285 113.453 59.6191 113.712 44.1097 113.965C42.9277 113.985 41.6261 113.965 40.7264 113.19C38.8506 111.571 40.5207 108.28 42.8272 107.375C45.1338 106.47 47.7609 106.843 50.1297 106.115C49.2301 104.649 49.5937 102.537 50.9337 101.455C52.7952 99.9459 54.1399 101.766 55.81 101.263C57.681 100.698 59.5043 97.7618 61.4615 96.8374Z",
    fill: "#F5FAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.115 108.687C245.176 107.789 242.734 107.633 240.978 108.843C239.222 110.048 238.56 112.263 238.177 114.327C237.405 112.778 235.592 111.788 233.836 111.956C232.08 112.124 230.5 113.441 230.05 115.109C229.891 115.7 229.834 116.371 229.372 116.782C228.972 117.137 228.384 117.181 227.845 117.205C225.575 117.309 223.304 117.412 221.034 117.516C219.739 117.576 218.175 117.804 217.669 118.973C217.228 119.991 217.93 121.2 218.919 121.735C219.907 122.27 221.087 122.302 222.218 122.318C235.453 122.533 248.688 122.749 261.922 122.96C262.931 122.976 264.042 122.96 264.809 122.314C266.41 120.965 264.985 118.223 263.017 117.468C261.048 116.714 258.806 117.025 256.785 116.419C257.553 115.197 257.243 113.437 256.099 112.535C254.511 111.278 253.363 112.794 251.938 112.375C250.341 111.904 248.786 109.457 247.115 108.687Z",
    fill: "#F5FAFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 206.24C11.25 205.826 11.5858 205.49 12 205.49H288C288.414 205.49 288.75 205.826 288.75 206.24C288.75 206.654 288.414 206.99 288 206.99H12C11.5858 206.99 11.25 206.654 11.25 206.24Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.469 204.738H129.572L133.626 190.638C134.103 189.337 135.941 189.337 136.418 190.638L140.469 204.738Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.739 195.244H132.303L133.156 192.271H136.889L137.739 195.244Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.16 200.176H130.885L131.738 197.203H138.303L139.16 200.176Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.542 204.738H127.5V205.677H142.542V204.738Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.943 204.738H232.043L236.097 190.638C236.574 189.337 238.412 189.337 238.889 190.638L242.94 204.738H242.943Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.213 195.244H234.773L235.626 192.271H239.359L240.213 195.244Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.63 200.176H233.355L234.209 197.203H240.774L241.63 200.176Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.012 204.738H229.971V205.677H245.012V204.738Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 161.58L176.52 173.1H184.2L172.68 161.58H165Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68 161.58L184.2 173.1H194.76L183.24 161.58H172.68Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 173.1H176.52L165 161.58V173.1Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.16 161.58H201.48L213 173.1H220.68L209.16 161.58Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24 161.58L194.76 173.1H202.44L190.92 161.58H183.24Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68 161.58H209.16L220.68 173.1V161.58Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92 161.58L202.44 173.1H213L201.48 161.58H190.92Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 178.86L176.52 190.38H184.2L172.68 178.86H165Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68 178.86L184.2 190.38H194.76L183.24 178.86H172.68Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 190.38H176.52L165 178.86V190.38Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.16 178.86H201.48L213 190.38H220.68L209.16 178.86Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24 178.86L194.76 190.38H202.44L190.92 178.86H183.24Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68 178.86H209.16L220.68 190.38V178.86Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92 178.86L202.44 190.38H213L201.48 178.86H190.92Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 203.014C165 202.399 165.499 201.9 166.114 201.9H175.406C176.021 201.9 176.52 202.399 176.52 203.014V204.627C176.52 205.242 176.021 205.74 175.406 205.74H166.114C165.499 205.74 165 205.242 165 204.627V203.014Z",
    fill: "#074E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.84 173.1H172.68V178.86H168.84V173.1Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.84 190.38H172.68V201.9H168.84V190.38Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.84 158.854C168.84 158.239 169.338 157.74 169.953 157.74H171.566C172.181 157.74 172.68 158.239 172.68 158.854V161.58H168.84V158.854Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 158.854C213 158.239 213.498 157.74 214.113 157.74H215.726C216.341 157.74 216.84 158.239 216.84 158.854V161.58H213V158.854Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 173.1H216.84V178.86H213V173.1Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 190.38H216.84V201.9H213V190.38Z",
    fill: "#BDDBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.16 203.014C209.16 202.399 209.659 201.9 210.274 201.9H219.567C220.182 201.9 220.68 202.399 220.68 203.014V204.627C220.68 205.242 220.182 205.74 219.567 205.74H210.274C209.659 205.74 209.16 205.242 209.16 204.627V203.014Z",
    fill: "#074E9F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_307_6415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.045 110.514L103.682 111.581L97.9889 114.432C97.9889 114.432 96.6092 124.539 107.392 124.272C114.349 121.318 114.788 119.728 114.64 117.627C114.606 117.184 116.147 114.221 115.774 113.848C115.346 113.509 114.895 113.202 114.424 112.929L112.751 111.959L107.045 110.514Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.543 114.542C105.743 114.396 104.405 112.813 104.551 111.013L104.984 105.742L111.505 106.28L111.073 111.55C110.926 113.35 109.349 114.688 107.543 114.542Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.768 106.083C104.768 106.083 105.936 110.174 109.214 110.033C112.083 109.911 111.312 105.838 111.312 105.838L104.768 106.089V106.083Z",
    fill: "#FCDAC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.597 95.4619L110.172 95.5238C113.06 95.8344 115.154 98.434 114.844 101.321L114.489 104.616C114.179 107.503 111.579 109.598 108.692 109.287L108.116 109.225C105.229 108.915 103.139 106.321 103.45 103.434L103.804 100.14C104.115 97.2524 106.715 95.1577 109.602 95.4683L109.597 95.4619Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.159 102.932C105.159 102.932 107.514 101.827 106.667 98.2864C106.667 98.2864 110.81 101.36 114.532 100.427C116.027 100.052 115.32 98.1828 114.374 96.9658C112.551 94.6285 107.771 91.6835 104.762 96.1186C104.762 96.1186 100.432 95.9725 102.442 102.371L105.159 102.926V102.932Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.159 102.932C105.048 103.966 104.119 104.708 103.091 104.597C102.062 104.486 101.314 103.557 101.425 102.529C101.536 101.495 102.466 100.753 103.494 100.864C104.528 100.975 105.27 101.904 105.159 102.932Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6073 113.871C99.6073 113.871 94.4631 113.649 93.7874 121.133C93.1912 127.759 101.248 127.839 101.248 127.839L99.6073 113.871Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.764 197.28L112.025 203.168L116.17 202.594L115.874 196.803L111.764 197.28Z",
    fill: "#FCDAC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.184 201.847C111.298 201.54 111.633 201.432 111.854 201.642C112.292 202.051 113.075 202.551 114.256 202.466C115.482 202.375 115.965 201.665 116.152 201.154C116.249 200.881 116.516 200.751 116.749 200.876L124.085 204.811C124.533 205.049 124.874 205.481 125.033 206.014C125.186 206.514 124.84 207.036 124.374 207.014L111.531 206.315C111.025 206.287 110.651 205.781 110.707 205.208L110.997 202.38C110.997 202.335 111.014 202.29 111.031 202.244L111.179 201.847H111.184Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.387 142.448L117.266 170.69L117.197 199.683L109.833 199.223L109.532 170.667L105.393 142.346L114.387 142.448Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0042 197.428L91.1411 203.253H95.2576L96.4045 197.178L92.0042 197.428Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.653 202.015C90.7666 201.708 91.1016 201.606 91.3231 201.81C91.7603 202.219 92.5438 202.719 93.7248 202.634C94.9569 202.543 95.4339 201.833 95.6212 201.322C95.7178 201.049 95.9846 200.919 96.2174 201.044L103.553 204.979C104.002 205.217 104.343 205.649 104.502 206.182C104.655 206.682 104.308 207.204 103.843 207.182L90.9994 206.483C90.4941 206.455 90.1193 205.949 90.1761 205.376L90.4657 202.548C90.4657 202.503 90.4827 202.458 90.4997 202.412L90.6474 202.015H90.653Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9093 142.262L96.2741 169.851L90.6416 199.285L97.1996 199.7L104.825 170.731L110.758 142.472L97.9093 142.262Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.709 128.208L119.552 122.162L114.262 124.663L120.175 131.453L123.709 128.208Z",
    fill: "#FCDAC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.152 113.471L117.568 113.914C118.69 114.323 119.561 115.223 119.935 116.357L122.757 124.97L114.448 126.506L116.152 113.471Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.916 115.62C132.916 117.498 131.395 119.019 129.517 119.019C127.64 119.019 126.114 117.498 126.114 115.62C126.114 113.743 127.634 112.217 129.517 112.217C131.4 112.217 132.916 113.737 132.916 115.62Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.866 115.706L119.93 127.83C118.744 130.241 119.768 131.382 120.856 132.028C122.122 132.778 123.331 132.364 124.327 130.875L130.601 117.334L127.866 115.706Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1472 113.47C99.1472 113.47 100.237 122.775 96.8534 126.585L96.1152 147.656C96.1152 147.656 106.415 152.67 116.039 147.735L116.588 120.31L116.152 113.47L112.751 111.959C112.751 111.959 111.726 116.701 107.634 116.205C102.904 115.632 103.682 111.581 103.682 111.581L99.1472 113.47Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.734 119.838C116.855 119.846 116.947 119.95 116.939 120.071L116.624 125.183C116.616 125.304 116.512 125.396 116.392 125.389C116.271 125.381 116.179 125.277 116.186 125.156L116.502 120.044C116.509 119.923 116.613 119.831 116.734 119.838Z",
    fill: "#074E9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7442 150.218L128.727 155.46C129.864 159.234 133.143 162.169 137.307 162.666C141.275 163.138 144.981 161.267 147.045 158.147L137.285 156.984C135.919 156.822 134.934 155.571 135.099 154.207L135.593 150.071C135.755 148.705 137.006 147.72 138.37 147.885L148.13 149.046C146.858 145.525 143.694 142.837 139.725 142.365C135.56 141.868 131.685 143.95 129.692 147.352L85.7096 142.112C84.5798 139.167 81.8989 136.928 78.5485 136.53C73.7343 135.956 69.3668 139.394 68.792 144.209C68.2173 149.023 71.6559 153.39 76.4702 153.965C79.8206 154.363 82.9522 152.821 84.7427 150.221L84.7442 150.218ZM72.4563 147.411L73.108 141.949L78.1625 139.783L82.5675 143.078L81.9159 148.539L76.8614 150.705L72.4563 147.411Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.087 151.116C125.18 150.409 124.684 149.76 123.976 149.668L88.3904 144.983C87.6831 144.89 87.0345 145.386 86.942 146.094C86.8495 146.801 87.3456 147.449 88.0528 147.542L123.637 152.228C124.344 152.32 124.992 151.824 125.085 151.117L125.087 151.116Z",
    fill: "#43BC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5374 149.98C99.3711 151.012 100.02 153.33 98.9877 155.158C97.9564 156.992 95.6382 157.641 93.81 156.608C91.9762 155.577 91.3269 153.259 92.3597 151.431C93.3909 149.597 95.7091 148.948 97.5374 149.98Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1789 118.358L90.1179 134.08C90.0477 134.377 90.0383 134.68 90.0976 134.976L93.3874 151.773L96.5695 150.882L94.6394 134.181L97.7849 126.213L93.1789 118.358Z",
    fill: "#FDEDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8231 132.163L99.194 125.782L103.51 118.79C102.724 118.796 102.859 117.881 99.1472 113.471C96.1624 114.814 92.8509 115.749 92.0652 118.753C91.1477 122.261 89.4406 127.572 89.3518 130.009L97.8231 132.163Z",
    fill: "#0A6EE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1761 125.563C97.2969 125.57 97.3888 125.674 97.3813 125.795L97.0658 130.908C97.0583 131.029 96.9544 131.121 96.8336 131.113C96.7128 131.106 96.6209 131.002 96.6284 130.881L96.9439 125.768C96.9513 125.647 97.0553 125.555 97.1761 125.563Z",
    fill: "#074E9F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_6415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 225,
    fill: "white",
    transform: "translate(0 -0.00976562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_307_6415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.5,
    height: 150,
    fill: "white",
    transform: "translate(47 74.9902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/serverError.c37925193e87fe6a526bd9cb95371bdf.svg";
export { ForwardRef as ReactComponent };